import _createForOfIteratorHelper from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { VOID, PRIMITIVE, ARRAY, OBJECT, DATE, REGEXP, MAP, SET, ERROR, BIGINT } from './types.js';
var EMPTY = '';
var _ref = {},
  toString = _ref.toString;
var keys = Object.keys;
var typeOf = function typeOf(value) {
  var type = typeof value;
  if (type !== 'object' || !value) return [PRIMITIVE, type];
  var asString = toString.call(value).slice(8, -1);
  switch (asString) {
    case 'Array':
      return [ARRAY, EMPTY];
    case 'Object':
      return [OBJECT, EMPTY];
    case 'Date':
      return [DATE, EMPTY];
    case 'RegExp':
      return [REGEXP, EMPTY];
    case 'Map':
      return [MAP, EMPTY];
    case 'Set':
      return [SET, EMPTY];
    case 'DataView':
      return [ARRAY, asString];
  }
  if (asString.includes('Array')) return [ARRAY, asString];
  if (asString.includes('Error')) return [ERROR, asString];
  return [OBJECT, asString];
};
var shouldSkip = function shouldSkip(_ref2) {
  var _ref3 = _slicedToArray(_ref2, 2),
    TYPE = _ref3[0],
    type = _ref3[1];
  return TYPE === PRIMITIVE && (type === 'function' || type === 'symbol');
};
var serializer = function serializer(strict, json, $, _) {
  var as = function as(out, value) {
    var index = _.push(out) - 1;
    $.set(value, index);
    return index;
  };
  var _pair = function pair(value) {
    if ($.has(value)) return $.get(value);
    var _typeOf = typeOf(value),
      _typeOf2 = _slicedToArray(_typeOf, 2),
      TYPE = _typeOf2[0],
      type = _typeOf2[1];
    switch (TYPE) {
      case PRIMITIVE:
        {
          var entry = value;
          switch (type) {
            case 'bigint':
              TYPE = BIGINT;
              entry = value.toString();
              break;
            case 'function':
            case 'symbol':
              if (strict) throw new TypeError('unable to serialize ' + type);
              entry = null;
              break;
            case 'undefined':
              return as([VOID], value);
          }
          return as([TYPE, entry], value);
        }
      case ARRAY:
        {
          if (type) {
            var spread = value;
            if (type === 'DataView') {
              spread = new Uint8Array(value.buffer);
            } else if (type === 'ArrayBuffer') {
              spread = new Uint8Array(value);
            }
            return as([type, _toConsumableArray(spread)], value);
          }
          var arr = [];
          var index = as([TYPE, arr], value);
          var _iterator = _createForOfIteratorHelper(value),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _entry = _step.value;
              arr.push(_pair(_entry));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return index;
        }
      case OBJECT:
        {
          if (type) {
            switch (type) {
              case 'BigInt':
                return as([type, value.toString()], value);
              case 'Boolean':
              case 'Number':
              case 'String':
                return as([type, value.valueOf()], value);
            }
          }
          if (json && 'toJSON' in value) return _pair(value.toJSON());
          var entries = [];
          var _index = as([TYPE, entries], value);
          var _iterator2 = _createForOfIteratorHelper(keys(value)),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var key = _step2.value;
              if (strict || !shouldSkip(typeOf(value[key]))) entries.push([_pair(key), _pair(value[key])]);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          return _index;
        }
      case DATE:
        return as([TYPE, value.toISOString()], value);
      case REGEXP:
        {
          var source = value.source,
            flags = value.flags;
          return as([TYPE, {
            source: source,
            flags: flags
          }], value);
        }
      case MAP:
        {
          var _entries = [];
          var _index2 = as([TYPE, _entries], value);
          var _iterator3 = _createForOfIteratorHelper(value),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _step3$value = _slicedToArray(_step3.value, 2),
                _key = _step3$value[0],
                _entry2 = _step3$value[1];
              if (strict || !(shouldSkip(typeOf(_key)) || shouldSkip(typeOf(_entry2)))) _entries.push([_pair(_key), _pair(_entry2)]);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          return _index2;
        }
      case SET:
        {
          var _entries2 = [];
          var _index3 = as([TYPE, _entries2], value);
          var _iterator4 = _createForOfIteratorHelper(value),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _entry3 = _step4.value;
              if (strict || !shouldSkip(typeOf(_entry3))) _entries2.push(_pair(_entry3));
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          return _index3;
        }
    }
    var message = value.message;
    return as([TYPE, {
      name: type,
      message: message
    }], value);
  };
  return _pair;
};

/**
 * @typedef {Array<string,any>} Record a type representation
 */

/**
 * Returns an array of serialized Records.
 * @param {any} value a serializable value.
 * @param {{json?: boolean, lossy?: boolean}?} options an object with a `lossy` or `json` property that,
 *  if `true`, will not throw errors on incompatible types, and behave more
 *  like JSON stringify would behave. Symbol and Function will be discarded.
 * @returns {Record[]}
 */
export var serialize = function serialize(value) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    json = _ref4.json,
    lossy = _ref4.lossy;
  var _ = [];
  return serializer(!(json || lossy), !!json, new Map(), _)(value), _;
};